// extracted by mini-css-extract-plugin
export default {"slide":"style_slide__a-sCC","content":"style_content__eVTct","circle":"style_circle__GCXs1","line1":"style_line1__OWETy","line2":"style_line2__NfN3a"};